<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Amber de Hebdan is from Essex, England. She loves writing in her spare time and lives in Kent. <em>A Book of Songs and Poetry</em>is Amber de Hebdan’s third book.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?d7cc5b80